import { useQuery } from '@tanstack/react-query';

import { findSimilarAccounts } from './helpers';
import type { SearchResults, SearchType } from './types';

type UseSimilarAccountsParams = {
  searchType: SearchType | null;
  searchValue: string | null;
  brand: string;
  enabled?: boolean;
};

export default function useSimilarAccounts({
  searchType,
  searchValue,
  brand,
  enabled = true,
}: UseSimilarAccountsParams) {
  const isEnabled = enabled && Boolean(searchType && searchValue);

  return useQuery<SearchResults>({
    queryKey: ['similar-accounts', brand, searchType, searchValue],
    queryFn: async ({ signal }) => {
      if (!searchType || !searchValue) {
        return { seedAccounts: [], similarAccounts: [] };
      }

      return findSimilarAccounts({
        searchType,
        searchValue,
        brand,
        signal,
      });
    },
    enabled: isEnabled,
    staleTime: 30_000,
    retry: false,
  });
}
